"use strict";
/**
 * @module botframework-streaming
 */
/**
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransportDisconnectedEvent = void 0;
/**
 * Event to be included when disconnection events are fired.
 */
var TransportDisconnectedEvent = /** @class */ (function () {
    /**
     * Indicates a transport disconnected with the reason provided via the constructor.
     *
     * @remarks
     * This class is used for communicating disconnection events between the
     * PayloadReceiver and PayloadSender.
     * @param reason The reason the disconnection event fired, in plain text.
     */
    function TransportDisconnectedEvent(reason) {
        this.reason = reason;
    }
    /**
     * A new and empty TransportDisconnectedEvent.
     */
    TransportDisconnectedEvent.Empty = new TransportDisconnectedEvent();
    return TransportDisconnectedEvent;
}());
exports.TransportDisconnectedEvent = TransportDisconnectedEvent;
//# sourceMappingURL=transportDisconnectedEvent.js.map